import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "export-icon-st0",
		d: "M10.9091 2.99914H7.63636V4.0846H10.9091V11.7373H1.09091V4.0846H4.36364V2.99914H1.09091C0.490909 2.99914 0 3.49005 0 4.09005V11.7264C0 12.3264 0.490909 12.8173 1.09091 12.8173H10.9091C11.5091 12.8173 12 12.3264 12 11.7264V4.09005C12 3.49005 11.5091 2.99914 10.9091 2.99914ZM10.9091 2.99914H7.63636V4.0846H10.9091V11.7373H1.09091V4.0846H4.36364V2.99914H1.09091C0.490909 2.99914 0 3.49005 0 4.09005V11.7264C0 12.3264 0.490909 12.8173 1.09091 12.8173H10.9091C11.5091 12.8173 12 12.3264 12 11.7264V4.09005C12 3.49005 11.5091 2.99914 10.9091 2.99914Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.18004 2.18182L5.99822 0L3.81641 2.18182H5.45277V7.09091H6.54368V2.18182H8.18004Z",
		fill: "currentColor"
	})]
});
export default SvgExportIcon;
